import React, { useCallback, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import {
  AnimatedContainer,
  ButtonLoadingForm,
  CheckboxLineForm,
  FormContainer,
} from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import { useUser } from '../../../hooks/user';
import getValidationErrors from '../../../utils/getValidationErrors';
import InputMask from '../../../components/InputMask';
import Checkbox from '../../../components/Checkbox';

interface formProps {
  cellphone: string;
  whatsapp: boolean;
}

export const Cellphone: React.FC<ComponentUserRegisterProps> = ({
  nextPage,
}) => {
  const formRef = useRef<FormHandles>(null);
  const [btnIsLoading, setBtnIsLoading] = useState<boolean>(false);

  const { setUser } = useUser();

  const handleNext = useCallback(async () => {
    const data = formRef?.current?.getData() as formProps;

    try {
      setBtnIsLoading(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        cellphone: Yup.string().required('Data de nascimento obrigatória'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      setUser(prev => ({ ...prev, phone: data.cellphone }));
      nextPage();
    } catch (err) {
      setBtnIsLoading(false);

      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }
    }
  }, [setUser, nextPage]);

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={1} titles={stepLabels} />

      <h1>Celular</h1>

      <FormContainer>
        <p>Informe o número do celular para a realização dos atendimentos:</p>

        <Form ref={formRef} onSubmit={handleNext}>
          <InputMask
            name="cellphone"
            label="Digite o seu número de celular"
            isRequired
            mask="(99) 9 9999-9999"
            type="tel"
          />

          <CheckboxLineForm>
            <Checkbox name="whatsapp" />

            <span>Esse celular é meu Whatsapp</span>
          </CheckboxLineForm>
        </Form>
      </FormContainer>
      <ButtonLoadingForm
        isLoading={btnIsLoading}
        btnType="darkBlue"
        onClick={handleNext}
      >
        Próximo
      </ButtonLoadingForm>
    </AnimatedContainer>
  );
};
